export default __webpack_public_path__ + "locales/ru/ResetApplicationDialog.json?hash=9d19c9b040491ba852d54286e28c5a94";